import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import clsx from 'clsx';
import { Children, ReactNode, useState } from 'react';

import styles from './ExpandableCardTableRow.module.scss';


interface ExpandableCardTableRowProps {
    children: ReactNode;
    expandedContent: ReactNode;
    slim?: boolean;
}

export function ExpandableCardTableRow({ children, expandedContent }: ExpandableCardTableRowProps) {
    const [ expanded, setExpanded ] = useState(false);

    return (
        <>
            <tr
                className={clsx({
                    [styles.rowExpanded]: expanded
                })}
            >
                <td className={styles.expandIconCell}>
                    <Tooltip title={`${expanded ? 'Hide' : 'Show'} details`}>
                        <IconButton
                            size="small"
                            onClick={() => setExpanded(!expanded)}
                        >
                            {expanded ? (
                                <ExpandLess color="secondary" />
                            ) : (
                                <ExpandMore color="secondary" />
                            )}
                        </IconButton>
                    </Tooltip>
                </td>

                {children}
            </tr>

            {expanded && (
                <tr>
                    <td className={styles.expandedRowCell}>
                        <div className={styles.expandedRowMask} />
                    </td>

                    <td
                        colSpan={Children.count(children)}
                        className={styles.expandedRowCell}
                    >
                        <div className={styles.expandedRowMask} />

                        {expandedContent}
                    </td>
                </tr>
            )}
        </>
    );
}
